import React, {forwardRef, useState} from 'react';
import BaseSimpleItemBrowser from "../BaseSimplePage/BaseSimpleItemBrowser";
import SchoolThemesItemBrowserHeader from "./SchoolThemesItemBrowserHeader";

const SchoolThemesItemBrowser = forwardRef(({
                                                  ...restProps
                                              }, ref) => {

    const [schoolClassId, setSchoolClassId] = useState(0);
    const [schoolSubjectId, setSchoolSubjectId] = useState(0);
    const [filterExtraParams, setFilterExtraParams] = useState({});

    function getItemSubtitle(item) {
        return `${restProps.refsData?.subjects?.[item.subject_id]?.name ?? "?"}, ${item.class} класс`;
    }

    function renderHeader(headerProps) {
        return <SchoolThemesItemBrowserHeader
            {...headerProps}
            schoolClassId={schoolClassId}
            setSchoolClassId={handleSchoolClassIdChange}
            schoolSubjectId={schoolSubjectId}
            setSchoolSubjectId={handleSchoolSubjectIdChange}
        />
    }

    function handleSchoolClassIdChange(value) {
        const newFilterExtraParams = {...filterExtraParams};
        if (value === 0)
            delete newFilterExtraParams.class;
        else
            newFilterExtraParams.class = value;

        setSchoolClassId(value);
        setFilterExtraParams(newFilterExtraParams);
        ref.current.onFilterEdit(true);
    }

    function handleSchoolSubjectIdChange(value) {
        const newFilterExtraParams = {...filterExtraParams};
        if (value === 0)
            delete newFilterExtraParams.subject_id;
        else
            newFilterExtraParams.subject_id = value;

        setSchoolSubjectId(value);
        setFilterExtraParams(newFilterExtraParams);
        ref.current.onFilterEdit(true);
    }

    return (
        <BaseSimpleItemBrowser
            {...restProps}
            ref={ref}
            getItemSubtitleFunc={getItemSubtitle}
            renderHeaderFunc={renderHeader}
            filterExtraParams={filterExtraParams}
        />
    );
});

export default SchoolThemesItemBrowser;